/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserRepresentation
 */
export interface UserRepresentation {
    /**
     * the unique identifier for the user within the company
     * @type {string}
     * @memberof UserRepresentation
     */
    key: string;
    /**
     * the unique username for the user within the company
     * @type {string}
     * @memberof UserRepresentation
     */
    username: string;
    /**
     * email of the user
     * @type {string}
     * @memberof UserRepresentation
     */
    email: string;
    /**
     * the unique identifier for the users company
     * @type {string}
     * @memberof UserRepresentation
     */
    companyKey: string;
    /**
     * optional users first name
     * @type {string}
     * @memberof UserRepresentation
     */
    firstname?: string;
    /**
     * optional users last name
     * @type {string}
     * @memberof UserRepresentation
     */
    lastname?: string;
    /**
     * optional avatar URI
     * @type {string}
     * @memberof UserRepresentation
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRepresentation
     */
    portfolioKey?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRepresentation
     */
    companyName?: string;
}

/**
 * Check if a given object implements the UserRepresentation interface.
 */
export function instanceOfUserRepresentation(value: object): value is UserRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('companyKey' in value) || value['companyKey'] === undefined) return false;
    return true;
}

export function UserRepresentationFromJSON(json: any): UserRepresentation {
    return UserRepresentationFromJSONTyped(json, false);
}

export function UserRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'username': json['username'],
        'email': json['email'],
        'companyKey': json['companyKey'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
        'image': json['image'] == null ? undefined : json['image'],
        'portfolioKey': json['portfolioKey'] == null ? undefined : json['portfolioKey'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
    };
}

export function UserRepresentationToJSON(json: any): UserRepresentation {
    return UserRepresentationToJSONTyped(json, false);
}

export function UserRepresentationToJSONTyped(value?: UserRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'username': value['username'],
        'email': value['email'],
        'companyKey': value['companyKey'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'image': value['image'],
        'portfolioKey': value['portfolioKey'],
        'companyName': value['companyName'],
    };
}

